<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Filter {{ utils.getLangTerm('toolbox-talks.plural', 'Toolbox Talks') }}</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    [matTooltip]="'Close Filter ' + utils.getLangTerm('toolbox-talks.plural', 'Toolbox Talks')"
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="filter-content d-flex m-0 pt-4 pb-2 flex-wrap" style="justify-content: space-evenly">

  <ng-container matColumnDef="sites">
    <div style="padding: 5px !important;">
      <button
        mat-raised-button
        type="button"
        (click)="onFilterSites()"
        [matBadge]="'' + (filters.site_ids.length || 'All')"
        class="mx-3 mt-2">
        <mat-icon>location_on</mat-icon> {{ utils.getLangTerm('parent-child-sites-combined.plural', 'Sites') }}
      </button>
    </div>
  </ng-container>

  <ng-container matColumnDef="reported_by">
    <div style="padding: 5px !important;">
      <button
        mat-raised-button
        type="button"
        (click)="onSelectReportedBy()"
        [matBadge]="'' + (filters.reported_by_ids.length || 'All')"
        class="mx-3 mt-2">
        <mat-icon>people</mat-icon> Reported By
      </button>
    </div>
  </ng-container>

  <ng-container matColumnDef="attendees">
    <div style="padding: 5px !important;">
      <button
        mat-raised-button
        type="button"
        (click)="onSelectAttendees()"
        [matBadge]="'' + (filters.attendee_ids.length || 'All')"
        class="mx-3 mt-2">
        <mat-icon>people</mat-icon> Attendees
      </button>
    </div>
  </ng-container>

  <ng-container matColumnDef="employees">
    <div style="padding: 5px !important;">
      <button
        mat-raised-button
        type="button"
        (click)="onSelectEmployees()"
        [matBadge]="'' + (filters.employee_ids.length || 'All')"
        class="mx-3 mt-2">
        <mat-icon>account_circle</mat-icon> {{ utils.getLangTerm('employees.plural', 'Employees') }}
      </button>
    </div>
  </ng-container>

  <ng-container matColumnDef="date_filter">
    <div style="padding: 0 1px !important;">
      <app-date-range-picker dateRangeTitle="Date Range" dateRangePlaceholder="Select Date Range" [dateRangeTooltip]="'Filter ' + utils.getLangTerm('toolbox-talks.plural', 'Toolbox Talks') + ' by created at date range.'" [dateRangeInput]="filters.date_range" (dateRangeOutput)="getOutputDateRange($event)"></app-date-range-picker>
    </div>
  </ng-container>

</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="d-flex flex-wrap justify-content-center my-2 py-2">

  <ng-container matColumnDef="buttons">
    <div class="p-2">
      <button
        type="button"
        mat-raised-button
        color="primary"
        (click)="onSaveAndClose()">
        <mat-icon>filter_list</mat-icon> Apply Filter
      </button>
    </div>

    <div class="p-2">
      <button
        type="button"
        mat-raised-button
        color="secondary"
        (click)="onClearAndClose()">
        <mat-icon> clear_all</mat-icon> Clear Filter
      </button>
    </div>

    <div class="p-2" *ngIf="filters.date_range.length == 2">
      <button
        type="button"
        mat-raised-button
        color="secondary"
        (click)="onClearDateRange()">
        <mat-icon>clear</mat-icon> Clear Date Range
      </button>
    </div>
  </ng-container>

</mat-dialog-actions>
